// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import FBSignInButton from 'vue-facebook-signin-button'
import BootstrapVue from 'bootstrap-vue'
import Vuex from 'vuex'
import store from './store/store'



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: {
    App
  },
  template: '<App/>'
})

Vue.use(FBSignInButton)
Vue.use(BootstrapVue)
Vue.use(Vuex)






// WEBPACK FOOTER //
// ./src/main.js